<template>
  <div>
    <div class="header-wrapper">
      <Header class="calculator-header" />
    </div>

    <section class="calculator-section">
      <div class="planes-bg" />
      <div class="clouds" />
      <div class="container">
        <div class="calculator-cont">
          <div class="calculator-wrap">
            <div class="wrap-title">
              <h2>Flight Calculator</h2>
              <p>The benefit programs are currently only valid for residents in Argentina.
              </p>
            </div>
            <div class="select-program" >
              <h4>Select Program:</h4>
              <div class="dropdown">
                <div class="select-s" @click="menuOpen = !menuOpen">
                  {{ program ? selectedProgram.text : 'Select program' }}
                </div>
                <div
                  v-show="menuOpen"
                  class="select-options">
                  <ul>
                    <li
                      v-for="option in programOptions"
                      :key="option.id"
                      @click="selectProgram(option.id)">{{ option.text }}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div v-if="descriptions && descriptions[program]" class="description helper-text">
              {{ descriptions[program] }}
            </div>

            <div
              v-if="program === 'NON_CUSTOMER'"
              class="both-wrap-div">
              <h3>Get in touch with our channels <br>
                to travel at incredible prices!
              </h3>
              <router-link :to="{ name: 'Contact' }">
                <button class="but btn-red">Contact</button>
              </router-link>
            </div>

            <template v-if="['SIGHT_ACCOUNT', 'INVESTMENT_B'].includes(program)">
              <div class="select-program">
                <h4>Amount* <span>(Average Annual Balance)</span></h4>
                <div
                  class="select-s2"
                  :class="{ error: $v.$dirty && $v.amount.$invalid }">
                  <input v-model="amount" type="number" placeholder="Enter amount">
                </div>
              </div>

              <span
                v-if="program === 'INVESTMENT_B'"
                class="helper-text">
                Minimum Required amount is $250,001
              </span>
            </template>

            <template v-if="program === 'INVESTMENT_A'">
              <div class="select-program">
                <h4>Select Amount: <span>(Minimum investment of one year)</span></h4>
                <div class="dropdown">
                  <div
                    class="select-s"
                    :class="{ error: $v.$dirty && $v.amount.$invalid }"
                    @click="amountSelectOpen = !amountSelectOpen">
                    {{ formattedAmount || 'Select amount' }}
                  </div>

                  <div
                    v-show="amountSelectOpen"
                    class="select-options">
                    <ul>
                      <li
                        v-for="option in investmentAOptions"
                        :key="option.id"
                        @click="selectAmount(option.id)">{{ option.text }}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </template>

            <div
              v-if="program && program !== 'NON_CUSTOMER'"
              class="btns-wrap-div">
              <button class="but btn-gray" @click="clear()">Cancel</button>
              <button class="but btn-red" @click="calculate()">Calculate</button>
            </div>

            <div
              v-if="result.text && result.value"
              class="result">
              <h4>{{ result.text }}:</h4>
              <h2>{{ result.value }}</h2>
              <div
                v-if="selectedProgram.resultText"
                class="pop-info">
                <p>{{ selectedProgram.resultText }}</p>
              </div>
            </div>

            <div v-if="selectedPlane" class="plane-info">
              <div class="plane-selector">
                <img
                  class="arrow-left"
                  src="@/assets/images/GeneralAssets/arrow-left.png"
                  @click="planePrev()" />
                <span>{{ selectedPlane.name }}</span>
                <img
                  class="arrow-right"
                  src="@/assets/images/GeneralAssets/arrow-right.png"
                  @click="planeNext()" />
              </div>

              <carousel
                v-if="planeImages"
                :images="planeImages" />

              <div class="plane-table">
                <div class="table-heading">
                  <div>Passengers</div>
                  <div>Flight Autonomy</div>
                  <div>Km per hour</div>
                  <div>Price per hour</div>
                </div>
                <div class="table-body">
                  <div>{{ selectedPlane.passengers }}</div>
                  <div>{{ selectedPlane.autonomy | distance }}</div>
                  <div>{{ selectedPlane.kmh | distanceperh }}</div>
                  <div>{{ selectedPlanePricePerHour | money }}</div>
                </div>
              </div>

              <div class="plane-table">
                <div class="table-heading">
                  <div>Presale of Hour packages</div>
                  <div>Plane Value</div>
                  <div>Value part of trust</div>
                  <div>Value part of trust amount</div>
                </div>
                <div class="table-body">
                  <div>{{ selectedPlane.package_sale ? `$${selectedPlane.package_sale}/h` : 'N/A' }}</div>
                  <div>{{ selectedPlane.val | money }}</div>
                  <div>{{ selectedPlane.value_of_trust }}%</div>
                  <div>{{ (selectedPlane.val * (selectedPlane.value_of_trust / 100 )) | money }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
import axios from 'axios'
import { required, decimal, minValue } from 'vuelidate/lib/validators'

import Carousel from '@/components/Carousel'
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'

export default {
  name: 'Calculator',

  components: {
    Header,
    Footer,
    Carousel
  },

  data () {
    return {
      menuOpen: false,
      amountSelectOpen: false,

      data: null,
      program: null,
      planes: null,

      amount: null,

      result: {
        text: null,
        value: null
      },

      descriptions: null,

      selectedPlaneIndex: 0,

      baseUrl: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_LOCAL_FILES_URL : process.env.VUE_APP_FILES_URL,

      programOptions: [
        {
          id: 'NON_CUSTOMER',
          text: 'Non Customer'
        },
        {
          id: 'SIGHT_ACCOUNT',
          text: 'Sight Account',
          amount_text: '(Average Annual Balance)',
          resultText: 'This is the maximum annual consumption that you can acquire to use the fleet at discounted prices. Contact us for more details.'
        },
        {
          id: 'INVESTMENT_A',
          text: 'Investment Fund A',
          amount_text: '(Minimum investment of one year)',
          resultText: 'This is the maximum annual consumption that you can acquire to use the fleet at discounted prices. Contact us for more details.'
        },
        {
          id: 'INVESTMENT_B',
          text: 'Investment Fund B',
          amount_text: '(Minimum investment of one year)',
          resultText: 'You can fly totally free for the amount of kilometers indicated. Contact us for more details.'
        }
      ],

      investmentAOptions: [
        {
          id: 100000,
          text: '$100,000'
        },
        {
          id: 125000,
          text: '$125,000'
        },
        {
          id: 150000,
          text: '$150,000'
        },
        {
          id: 175000,
          text: '$175,000'
        },
        {
          id: 200000,
          text: '$200,000'
        },
        {
          id: 225000,
          text: '$225,000'
        },
        {
          id: 250000,
          text: '$250,000'
        }
      ]
    }
  },

  computed: {
    selectedPlane () {
      if (!this.planes) return
      return this.planes[this.selectedPlaneIndex]
    },

    selectedPlanePricePerHour () {
      if (!this.selectedPlane) return

      const values = {
        NON_CUSTOMER: this.selectedPlane.fintech_phc,
        SIGHT_ACCOUNT: this.selectedPlane.sight_acc_phc,
        INVESTMENT_A: this.selectedPlane.investemnt_a_phc,
        INVESTMENT_B: this.selectedPlane.investemnt_b_phc
      }

      return values[this.program]
    },

    planeImages () {
      if (!this.selectedPlane) {
        return null
      }

      const images = []

      for (let i = 1; i <= 5; i++) {
        const image = this.selectedPlane[`image${i}`]
        if (image) images.push(`${this.baseUrl}/flight-inventory/${image}`)
      }

      return images
    },

    selectedProgram () {
      return this.programOptions.find(option => option.id === this.program)
    },

    formattedAmount () {
      return this.amount ? this.formatMoney(this.amount) : null
    }
  },

  watch: {
    program () {
      this.clear(false)
    },

    amountSelectOpen (value) {
      if (value) this.menuOpen = false
    },

    menuOpen (value) {
      if (value) this.amountSelectOpen = false
    }
  },

  created () {
    document.title = `Calculadora - ${process.env.VUE_APP_TITLE}`

    this.load()

    const availablePrograms = this.programOptions.map(option => option.id)
    const preselected = this.$route.query.select
    if (availablePrograms.includes(preselected)) {
      this.program = preselected
    }
  },

  methods: {
    planePrev () {
      this.selectedPlaneIndex = (this.selectedPlaneIndex - 1 + this.planes.length) % this.planes.length
    },

    planeNext () {
      this.selectedPlaneIndex = (this.selectedPlaneIndex + 1) % this.planes.length
    },

    formatMoney (value) {
      return '$ ' + Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(value)
    },

    selectAmount (amount) {
      this.amount = amount
      this.amountSelectOpen = false
    },

    selectProgram (id) {
      this.program = id
      this.menuOpen = false
    },

    calculate () {
      this.$v.$touch()
      if (this.$v.$invalid) return

      if (this.program === 'SIGHT_ACCOUNT') {
        this.result.text = 'Negotiable Benefit'
        this.result.value = this.formatMoney(this.amount * (this.data.sight_acc_bonus / 100))
      }

      if (this.program === 'INVESTMENT_A') {
        this.result.text = 'Negotiable Benefit'
        this.result.value = this.formatMoney(this.amount * (this.data.a_customer_bonus / 100))
      }

      if (this.program === 'INVESTMENT_B') {
        this.result.text = 'Flight KMs'
        this.result.value = Math.round(this.amount * (this.data.b_rate / 100) / this.data.b_cost_per_km) + ' km'
      }
    },

    clear (clearProgram = true) {
      if (clearProgram) {
        this.program = null
      }
      this.amount = null
      this.result = {
        text: null,
        value: null
      }
      this.$v.$reset()
    },

    async load () {
      try {
        const { data } = await axios.get('flight-data')
        this.data = data
        const planeResponse = await axios.get('planes')
        this.planes = planeResponse.data
        const response = await axios.get('program-descriptions')
        this.descriptions = {
          NON_CUSTOMER: response.data.non_customer,
          SIGHT_ACCOUNT: response.data.sight_account,
          INVESTMENT_A: response.data.investment_a,
          INVESTMENT_B: response.data.investment_b
        }
      } catch (e) {
        console.error(e)
      }
    }
  },

  validations () {
    const rules = {}

    if (['SIGHT_ACCOUNT', 'INVESTMENT_A', 'INVESTMENT_B'].includes(this.program)) {
      rules.amount = { required, decimal }
    }

    if (this.program === 'INVESTMENT_B') {
      rules.amount.minValue = minValue(250001)
    }

    return rules
  }
}
</script>

<style lang="scss" scoped>
  .header-wrapper {
    width: 100%;
    height: 125px;
    background-color: #fff;
  }
  .calculator-section {
    background: rgb(255,255,255);
    background: linear-gradient(124deg, rgba(255,255,255,1) 0%, rgba(164,74,221,1) 100%);
    position: relative;
    .planes-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 450px;
      background-image: url(../assets/images/calculator-planes.jpg);
      background-position: center;
      background-size: cover;
      z-index: 2;
    }
    .clouds {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 800px;
      background-image: url(../assets/images/calculator-bg.png);
      background-position: bottom right;
      background-size: contain;
      background-repeat: no-repeat;
      z-index: 1;

    }
  }
  .image-back-cont {
    min-height:720px
  }
  .plane-info {
    width: 100%;
    max-width: 520px;
    margin-top: 80px;
    .plane-selector {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .arrow-left, .arrow-right {
        width: 40px;
        height: 40px;
        cursor: pointer;
        border-radius: 50%;
      }
      span {
        font-size: 40px;
        font-family: AvenirNextLTPro-MediumCn;
        color: #000;
      }
    }
  }
  .description {
    display: block;
    width: 100%;
    max-width: 520px;
    text-align: left;
    margin-bottom: 15px;
  }
  .helper-text {
    font-size: 14px;
    color: #636166;
    font-family: AvenirNextLTPro-Regular;
  }

  .plane-table {
    width: 100%;
    margin-top: 20px;
    .table-heading {
      display: flex;
      background: rgb(191,163,242);
      background: linear-gradient(124deg, rgba(191,163,242,1) 0%, rgba(237,227,252,1) 100%);
      border-radius: 20px;
      font-family: AvenirNextLTPro-MediumCn;
      font-size: 15px;
      font-weight: bold;
      padding: 15px 0;
      div {
        width: 25%;
        text-align: center;
        padding: 0 10px;
      }
    }
    .table-body {
      display: flex;
      padding: 20px 0;
      font-family: AvenirNextLTPro-MediumCn;
      font-size: 14px;
      font-weight: bold;
      div {
        width: 25%;
        text-align: center;
        padding: 0 10px;
      }
    }
  }
</style>
